import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AccordionStateDetails {
    value: any;
}



const initialState: AccordionStateDetails = {
    value : ''
};



const setAccordionStateDetailsSlice = createSlice({
  name: "setAccordionStateValue",
  initialState: initialState,
  reducers: {
    setAccordionStateDetails: (state,  action: PayloadAction<any>) => {
      state.value = action.payload;
    }
  }
});

export const { setAccordionStateDetails } = setAccordionStateDetailsSlice.actions;

export default setAccordionStateDetailsSlice.reducer;